export default __webpack_public_path__ + "static/media/Belgium-vs-Russia.1e12cb53.jpeg";